module.exports = __webpack_public_path__ + "static/media/industria-subheader.72b253e3.jpg";